import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-sm font-medium text-gray-400" }
const _hoisted_3 = { class: "text-base font-semibold text-gray-900 mt-2" }




export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryItem',
  props: {
  label: {
    type: String,
    required: true
  },
  value: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.value), 1)
  ]))
}
}

})